import { MENU_DATA } from "@/components/Layout/Header";
import { useRouter } from "next/router";

import { useMemo } from "react";

export function useActivePathCheck() {
  const router = useRouter();

  const activePath = useMemo(() => {
    const path = router.asPath;

    if (path === "/") return "홈";
    if (path.startsWith(MENU_DATA["견적"].to)) {
      return MENU_DATA["견적"].activePath;
    }
    if (path.startsWith(MENU_DATA["가이드북"].to)) {
      return MENU_DATA["가이드북"].activePath;
    }
    if (path.startsWith(MENU_DATA["후기"].to)) {
      return MENU_DATA["후기"].activePath;
    }

    return "";
  }, [router.asPath]);

  return { activePath };
}
